import PropTypes from 'prop-types'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'

class AlertDialog extends DialogBase {
  static propTypes = {
    context: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string.isRequired
    }).isRequired
  }
  modalSize () { return dialogSizes.SM }
  modalTitle () { return this.props.context.title || super.modalTitle() }
  modalBody () { return this.props.context.message }
}

export default AlertDialog
